export var Resident360;
(function (Resident360) {
    let type;
    (function (type) {
        type["RESIDENT360"] = "Resident360";
    })(type = Resident360.type || (Resident360.type = {}));
})(Resident360 || (Resident360 = {}));
